import { render, staticRenderFns } from "./headerSection.vue?vue&type=template&id=31ca9d53&scoped=true&"
import script from "./headerSection.vue?vue&type=script&lang=js&"
export * from "./headerSection.vue?vue&type=script&lang=js&"
import style0 from "./headerSection.vue?vue&type=style&index=0&id=31ca9d53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca9d53",
  null
  
)

export default component.exports